module.exports = __webpack_public_path__ + "static/media/plant.97866f4f.png";